import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { VALIDATE_TOKEN, VALIDATE_TOKEN_SUCCESS, VALIDATE_TOKEN_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* validateToken({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/v1/validate-reset-link`,
      method: 'POST',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        // ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
        'X-Requested-By': 'one-admin',
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      // cogoToast.success(response?.data?.message);
      yield put({
        type: VALIDATE_TOKEN_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: VALIDATE_TOKEN_ERROR,
        payload: response?.data,
      });
    }
  } catch (error) {
    yield put({ type: VALIDATE_TOKEN_ERROR, payload: error });
  }
}

export function* watchValidateToken() {
  yield takeEvery(VALIDATE_TOKEN, validateToken);
}

function* validateTokenSaga() {
  yield all([fork(watchValidateToken)]);
}

export default validateTokenSaga;
